import { render, staticRenderFns } from "./ConversationsList.vue?vue&type=template&id=cbbf5dc0&scoped=true"
import script from "./ConversationsList.vue?vue&type=script&lang=js"
export * from "./ConversationsList.vue?vue&type=script&lang=js"
import style0 from "./ConversationsList.vue?vue&type=style&index=0&id=cbbf5dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbf5dc0",
  null
  
)

export default component.exports